import styled from 'styled-components';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import { GDBREAKPOINTS_FINAL_MINI, GAME_CONTEXT_BREAKPOINTS } from '@gameday/components/themes/breakpoints';
import { CardWrapper } from '../Card/Card.style';
import { InnerWrapper, LeftButton, RightButton, OuterWrapper } from '@mlb/react-patterns/v4/components/ControlledOverflow/controlledOverflow.style';
import Image from '@mlb/react-patterns/v4/components/Image/image';

const { XS_MAX } = GDBREAKPOINTS_FINAL_MINI;
const { DESKTOP } = GAME_CONTEXT_BREAKPOINTS;
export const TitleWrapper = styled.div`
    font-size: 24px;
    font-weight: bold;
    font-family: var(--gameday-primary-font);
    margin-bottom: 20px;
    ${({ showCarousel }) => showCarousel
    ? `
        margin: 0px 0px 16px 16px;
    `
    : ''}

    ${({ $viewType }) => $viewType === 'mini'
    ? `
        margin: var(--gameday-section-padding-sm); 0px var(--gameday-section-padding-sm); var(--gameday-section-padding-sm);;
        font-size: 16px;
        font-weight: 700;
    `
    : ''}
`;

export const PlayerWrapper = styled.div`
    flex: 1 1 0;
    text-align: center;
    margin-bottom: -2px;
`;

export const PlayerHeaderWrapper = styled.div`
    display: block;
    position: relative;
    line-height: 16px;
    padding-top: 1px;
`;

export const PlayerNameWrapper = styled(Link)`
    display: inline-block;
    font-size: 18px;
    font-weight: bold;
    color: var(--gameday-primary-font-color) !important;
    ${({ $noHover }) => $noHover
    ? ''
    : `
        @media (hover: hover) {
            &:hover {
                color:var(--gameday-link-color) !important;
            }
        }
    `}
`;

export const PlayerStatsWrapper = styled.div`
    margin-top: 0;
    font-size: 14px;
    line-height: 14px;
    color: var(--gameday-top-performer-stat-color);
    font-weight: bold;
    padding-top: 4px;
`;

export const TwoWayLabel = styled.div`
    font-size: 13px;
    font-weight: bold;
    display: inline-block;
    margin-right: 8px;
    color: var(--gameday-two-way-top-performers-label);
`;

export const PlayerListWrapper = styled.div`
    display: flex;
    ${PlayerWrapper} {
        :not(:last-child){
            border-right: 1px solid var(--gameday-divider-color);
        }
    }
`;

export const TopPerformersWrapper = styled.div`
    font-family: var(--gameday-primary-font);

    ${OuterWrapper} {
        ${LeftButton},
        ${RightButton} {
            height: 40px;
            width: 40px;
            background-color: var(--gameday-video-carousel-button-color);
            &:hover {
                background-color: var(--gameday-video-carousel-button-color-hover);
            }
        }
    }

    ${({ $viewType }) => $viewType === 'mini' && `
        align-items: stretch !important;
        padding-bottom: 16px;

        button {
            display:none !important;
        }

        ${InnerWrapper} {
            width: calc(100% - 32px);
            min-width: calc(100% - 32px);
            margin: 0 auto;
            justify-content: center;
            align-items: center;

            ${CardWrapper} {
                flex-grow: 1;
                flex-shrink: 1;
                flex-basis: 0;
                min-width: 93px;
                min-height: 186px;
                margin: 0;
                padding:0;
                overflow:hidden;
                padding-top:32px;

                @media (max-width: ${XS_MAX}) {
                    padding-top: var(--gameday-section-padding-sm);
                    background-color: var(--gameday-background-color);;
                    min-height: 136px;
                }

            }

            > div {
                &:last-child {
                    display:none;
                }

                &:not(:first-child):not(:last-child) {
                    margin-left: var(--gameday-section-padding-sm);
                    @media (max-width: ${XS_MAX}) {
                        margin-left: 2px;
                    }
                }
            }
        }

    `};

    ${({ showCarousel }) => showCarousel && `
        ${InnerWrapper} {
            padding-left: 16px;
            scroll-padding-left: 16px;
            align-items: stretch !important;

            ${CardWrapper} {
                margin: 1px 8px;
                padding: 16px 8px;
                width: 140px;
                padding-bottom: 13px;

                &:first-child {
                    margin-left: 0px;
                }
                &:last-child {
                    margin-right: 32px;
                }

                ${PlayerWrapper} {
                    margin-bottom: 0px;
                    >div {
                        &:last-child {
                            margin-left: 0px;
                        }
                    }
                }
            }
        }

    `
}
`;

export const PlayerStoryActionShot = styled(Image)`
    border-radius: 64px;
    overflow: hidden;
    width: ${({ size }) => size};
    height: ${({ size }) => size};
    border: 4px solid var(--gameday-top-performers-accent-color);
    outline: 2px solid white;
    outline-offset: -4px;
    @media (min-width: ${DESKTOP}) {
        border-width: 6px;
        outline-width: 3px;
        outline-offset: -6px;
    }
    box-sizing: border-box;
`;

export const HeadshotSkeletonWrapper = styled.div`
    display: flex;
    justify-content: center;
`;
